import { ApolloProvider } from '@apollo/client';
import { AppConfig } from '../../types/app-config';
import { client } from '../../utils/apollo';
import Layout from './layout';

export function SignupLayout({
  children,
  header = <></>,
  config,
  ...props
}: {
  children?: JSX.Element | JSX.Element[];
  header: React.ReactNode;
  config?: AppConfig;
  updateConfig?: () => Promise<void>;
}): JSX.Element {
  return (
    <ApolloProvider client={client}>
      <Layout header={header} config={config} {...props}>
        {children}
      </Layout>
    </ApolloProvider>
  );
}
